// Damage direction arcs (a ring of fading arcs around the crosshair) and the red hit flash.

import { div, play } from "./dom";
import { damageArcRotationDeg, damageArcStrength } from "./format";

const POOL = 8;
const FADE_MS = 1150;
const FLASH_MS = 420;

// Arc of 44 degrees at radius 190 inside a 400x400 box, centred on the top of the ring.
const ARC_SVG =
  '<svg viewBox="0 0 400 400" fill="none" stroke-linecap="round" aria-hidden="true" focusable="false">' +
  '<path class="hud-darc__glow" d="M128.8 23.8A190 190 0 0 1 271.2 23.8"/>' +
  '<path class="hud-darc__core" d="M128.8 23.8A190 190 0 0 1 271.2 23.8"/></svg>';

export class DamageLayer {
  readonly root = div("hud-darcs");
  private readonly flash = div("hud-dmgflash");
  private readonly arcs: HTMLDivElement[] = [];
  private next = 0;

  constructor() {
    for (let i = 0; i < POOL; i++) {
      const a = div("hud-darc");
      a.innerHTML = ARC_SVG;
      a.style.opacity = "0";
      this.arcs.push(a);
      this.root.append(a);
    }
    this.flash.style.opacity = "0";
    this.root.append(this.flash);
  }

  /** `dirRad`: source direction relative to the view, 0 = ahead, + = left. */
  hit(dirRad: number, amount: number): void {
    const a = this.arcs[this.next]!;
    this.next = (this.next + 1) % POOL;
    const strength = damageArcStrength(amount);
    a.style.transform = `rotate(${damageArcRotationDeg(dirRad).toFixed(1)}deg)`;
    play(
      a,
      [{ opacity: strength }, { opacity: strength, offset: 0.3 }, { opacity: 0 }],
      { duration: FADE_MS, easing: "ease-out" },
    );
    play(this.flash, [{ opacity: 0.16 + 0.3 * strength }, { opacity: 0 }], { duration: FLASH_MS, easing: "ease-out" });
  }

  clear(): void {
    for (const a of this.arcs) for (const an of a.getAnimations()) an.cancel();
    for (const an of this.flash.getAnimations()) an.cancel();
  }
}
